import Constants from '@/lib/constants'
export default class ChildInformation {
  // お子様情報
  selectedAboutChildren = Constants.CHILD_INFORMATION_INDEXES.PREGNANCY

  childDate = ''
  image = null
  childName = ''
}
